import React from 'react';
import { useTranslate } from '../../../mixins/translate/translate';
import { openApiFetchGet } from '../../../store/openApiFetch';
import { PanelBody, PanelButtonLink, PanelHeading, PanelSpacing } from '../../elements';
import { Spinner } from '../../spinners';
import { DocumentsGrid } from '../../utils/DocumentsGrid';
import { DocumentsList } from '../../utils/DocumentsList';
import { useReactAsync } from '../../utils/useReactAsync';

async function loadEquipmentAssets({ equipmentId }: { equipmentId: string }) {
    const result = await openApiFetchGet('/api/equipmentAsset', { equipmentId });
    return result;
}

export function EquipmentDocumentList(props: { equipmentId: string }) {
    const translate = useTranslate();
    const { data, isLoading } = useReactAsync(loadEquipmentAssets, { equipmentId: props.equipmentId }, [props.equipmentId]);
    const [isListVisible, setIsListVisible] = React.useState<boolean>(false);

    return (
        <>
            <PanelHeading text={translate('survey.documents')} icon="fa fa-book">
                {(isListVisible && (
                    <PanelButtonLink onClick={() => setIsListVisible(false)} text={translate('equipment.gridView')} icon="fa fa-th" small={true} />
                )) || (
                    <PanelButtonLink onClick={() => setIsListVisible(true)} text={translate('equipment.listView')} icon="fa fa-list" small={true} />
                )}
            </PanelHeading>
            <PanelBody noPadding={true}>
                {(isLoading && <Spinner />) || (
                    <>
                        {data && !isListVisible && (
                            <PanelSpacing>
                                <DocumentsGrid assets={data} equipmentId={props.equipmentId} />
                            </PanelSpacing>
                        )}
                        {data && isListVisible && <DocumentsList assets={data} equipmentId={props.equipmentId} />}
                    </>
                )}
            </PanelBody>
        </>
    );
}
